import BaseController       from "controllers/base"
import { placesUri }        from "servos/googlePlaces"
import NewProjectForm       from 'widgets/project/newForm';


class Controller extends BaseController {
  call() {
    bindCustomWorkDescriptions.call(this)
    bindProjectType.call(this);
    bindBuilderType.call(this)
    bindZoning.call(this)
    try { new NewProjectForm(this.root); } catch(e) { console.warn('NewProjectForm failed:', e) }
  }

  scripts() {
    return [placesUri]
  }
};

let bindCustomWorkDescriptions = function() {
  this.root.find('.works-description').on('change', (e) => {
    toggleAdditionalWorksDescription.call(this, e.currentTarget.value)
  })
}

let toggleAdditionalWorksDescription = function(value) {
  if (value == 'custom') {
    this.root.find('.additional-works-description').removeClass('d-none')
    this.root.find('.additional-works-description input').prop('disabled', false)
  } else {
    this.root.find('.additional-works-description').addClass('d-none')
    this.root.find('.additional-works-description input').prop('disabled', true)
  }
}

const bindProjectType = function() {
  this.root.find('.submit-checklist-template').on('click', (e) => {
    let selected = this.root.find('.select-checklist').val()
    console.log(selected);
    this.root.find("input.project-type").val(selected)
    this.root.find("form").submit()
  })
}

let bindBuilderType = function() {
  this.root.find('.builder-type').on('change', (e) => {
    let selected = e.currentTarget.value
    if (selected == 'contractor_unlicensed') {
      $('.builder-details').addClass('d-none')
      $('#new_project_form_licence').val('')
    } else {
      $('.builder-details').removeClass('d-none')
    }
  })
}

let toggleCustomZoning = function(value) {
  if (value == 'custom') {
    $('.custom-zoning').removeClass('d-none')
  } else {
    $('.custom-zoning').addClass('d-none')
  }
}

let bindZoning = function() {
  toggleCustomZoning($('#new_project_form_zoning').val())
  this.root.find('#new_project_form_zoning').on('change', (e) => {
    toggleCustomZoning(e.currentTarget.value)
  })
}

export default Controller;
